import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/imgs/mail_fill.webp';
const _hoisted_1 = {
  id: "app"
};
const _hoisted_2 = {
  key: 2,
  style: {
    "position": "fixed",
    "right": "5%",
    "bottom": "5%",
    "width": "7rem",
    "height": "7rem",
    "z-index": "100000"
  }
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  style: {
    "height": "100%"
  },
  src: _imports_0,
  alt: "icon"
}, null, -1);
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  key: 0,
  class: "cookieDiv"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "We would like to use cookies to better understand your use of this website. We only capture your page views, which will help improve your experience the next time you visit this website. If you click the confirmation button on the right, you will be deemed to agree to the use of cookies.", -1);
const _hoisted_7 = {
  class: "aDiv"
};
const _hoisted_8 = {
  key: 1,
  class: "cookieDivMobile"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "We would like to use cookies to better understand your use of this website. We only capture your page views, which will help improve your experience the next time you visit this website. If you click the confirmation button on the right, you will be deemed to agree to the use of cookies.", -1);
const _hoisted_10 = {
  class: "aDiv"
};
import { ref, onMounted } from "vue";
import { useStore } from "./store";
import { useRoute } from "vue-router";
export default {
  __name: 'App',
  setup(__props) {
    const router = useRoute();
    const screenWidth = ref(0);
    const timer = ref(null);
    const store = useStore();
    const cookieDivOr = ref(false);
    onMounted(() => {
      screenWidth.value = document.body.clientWidth;
      document.getElementsByTagName("html")[0].style.fontSize = "12px";
      store.setScreenWidth(document.body.clientWidth);
      window.onscroll = () => {
        store.setScrollHeight_before();
        store.setScrollHeight(document.body.scrollTop || document.documentElement.scrollTop);
      };
      window.addEventListener("resize", () => {
        if (!timer.value) {
          timer.value = setTimeout(function () {
            screenWidth.value = document.body.clientWidth;
            document.getElementsByTagName("html")[0].style.fontSize = "12px";
            store.setScreenWidth(document.body.clientWidth);
            timer.value = null;
          }, 400);
        }
      });
    });
    function gtag_report_conversion(url) {
      var callback = function () {
        if (typeof url != "undefined") {
          window.location = url;
        }
      };
      gtag("event", "conversion", {
        send_to: "AW-949439480/4SCwCPfLsvQYEPiX3cQD",
        event_callback: callback
      });
      return false;
    }
    function getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) != -1) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      console.info(cname + "=" + cvalue + "; " + expires);
      document.cookie = cname + "=" + cvalue + "; " + expires;
    }
    function checkCookie() {
      var user = getCookie("accept");
      if (user != "") {
        cookieDivOr.value = false;
      } else {
        gtag("consent", "default", {
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied",
          analytics_storage: "denied"
        });
        cookieDivOr.value = true;
      }
    }
    function closeDiv(result) {
      setCookie("accept", result, 1000); //设置天数
      if (result == "accept") {
        gtag("consent", "update", {
          ad_storage: "granted",
          ad_user_data: "granted",
          ad_personalization: "granted",
          analytics_storage: "granted"
        });
      } else {
        gtag("consent", "update", {
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied",
          analytics_storage: "denied"
        });
      }
      cookieDivOr.value = false;
    }
    checkCookie();
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [!_unref(store).isPC ? (_openBlock(), _createBlock(_component_router_view, {
        key: 0
      }, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: _unref(router).name
        }))], 1024))]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_router_view, {
        key: 1
      }, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: _unref(router).name
        }))]),
        _: 1
      })), _unref(store).isPC ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("a", {
        href: "mailto:info@fusteel.com",
        class: "email_address",
        onClick: _cache[0] || (_cache[0] = $event => gtag_report_conversion())
      }, _hoisted_4)])) : _createCommentVNode("", true)]), cookieDivOr.value && _unref(store).isPC ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("span", {
        onClick: _cache[1] || (_cache[1] = $event => closeDiv('accept'))
      }, "accept"), _createElementVNode("span", {
        onClick: _cache[2] || (_cache[2] = $event => closeDiv('reject'))
      }, "reject")])])) : _createCommentVNode("", true), cookieDivOr.value && !_unref(store).isPC ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("span", {
        onClick: _cache[3] || (_cache[3] = $event => closeDiv('accept'))
      }, "accept"), _createElementVNode("span", {
        onClick: _cache[4] || (_cache[4] = $event => closeDiv('reject'))
      }, "reject")])])) : _createCommentVNode("", true)], 64);
    };
  }
};